import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import TwoOptionSelector from '../../UI/Selectors/TwoOptionsSelector/TwoOptionsSelector';
import MotorDataVoltageItems from './MotorDataVoltageItems/MotorDataVoltageItems';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MotorVoltageComponent extends Component {
  state = {
    selectedES: true,
    selectedOS: false
  };

  handleESSelection = () => {
    this.setState({
      selectedES: true,
      selectedOS: false
    });
  };

  handleOSSelection = () => {
    this.setState({
      selectedES: false,
      selectedOS: true
    });
  };

  render() {
    const { selectedES, selectedOS } = this.state;
    const { country, language } = this.props;

    return (
      <Fragment>
        <MotorDataVoltageItems
          selectedES={selectedES}
          country={country}
          language={language}
        />
        <TwoOptionSelector
          title1={LocalizedStrings[language].enclosedStarters}
          title2={LocalizedStrings[language].openStyle}
          select1={this.handleESSelection}
          select2={this.handleOSSelection}
          selected1={selectedES}
          selected2={selectedOS}
        />
      </Fragment>
    );
  }
}

MotorVoltageComponent.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default MotorVoltageComponent;
